import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-hot-toast";

const AddInsurance = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const server_url = localStorage.getItem("server_url");
  const company_id = localStorage.getItem("company_id") || "2";
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const grage_id = userData.grage_id || "1";

  const isEdit = location.pathname.includes("edit");
  const existingInsurance = location.state?.insurance;

  const SearchableDropdown = ({
    options = [],
    value,
    onChange,
    placeholder,
    name,
    error,
    loading,
    disabled,
    required,
  }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [filteredOptions, setFilteredOptions] = useState(options);
    const dropdownRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
      const filtered = options.filter((option) =>
        option.label.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredOptions(filtered);
    }, [searchTerm, options]);

    useEffect(() => {
      const selected = options.find((opt) => opt.value == value);
      setSearchTerm(selected ? selected.label : "");
    }, [value, options]);

    const handleInputChange = (e) => {
      setSearchTerm(e.target.value);
      setIsOpen(true);
    };

    const handleSelect = (selectedValue) => {
      setIsOpen(false);
      if (onChange) onChange({ target: { name, value: selectedValue } });
    };

    const displayValue = options.find((opt) => opt.value == value)?.label || "";
    const inputValue = isOpen ? searchTerm : displayValue;

    return (
      <div className="searchable-dropdown" ref={dropdownRef}>
        <div className={`input-group ${error ? "error" : ""}`}>
          <div className="input-icon"><i className="fas fa-search"></i></div>
          <input
            type="text"
            className="form-input"
            placeholder={placeholder}
            value={inputValue}
            onChange={handleInputChange}
            onFocus={() => setIsOpen(true)}
            disabled={disabled || loading}
            readOnly={!isOpen}
            required={required}
          />
          {isOpen && (
            <ul className="dropdown-list" style={{ width: "70%", textAlign: "left" }}>
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option) => (
                  <li
                    style={{ padding: "5px", margin: "2px" }}
                    key={option.value}
                    className="dropdown-item"
                    onClick={() => handleSelect(option.value)}
                  >
                    {option.label}
                  </li>
                ))
              ) : (
                <li className="dropdown-item no-results">No results found</li>
              )}
            </ul>
          )}
        </div>
        {error && (
          <div className="error-message">
            <i className="fas fa-exclamation-circle"></i>{error}
          </div>
        )}
        {loading && <div className="loading-message">Loading...</div>}
      </div>
    );
  };

  const [formData, setFormData] = useState({
    vehicle_id: "",
    insurance_company_id: "",
    insurance_start_date: "",
    insurance_valid_till: "",
    insurance_amount: "",
    insurance_remark: "",
    insurance_policy_number: "",
    insurance_idv: "",
    insurance_cng: "",
    insurance_ncb: "",
    insurance_under_sgm: "1",
    insurance_type: [],
    insurance_policy_document: null,
    insurance_video: null,         // NEW: video upload
    insurance_document: null,      // NEW: extra document (PDF)
    insurance_grage_id: grage_id,
  });

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [vehicles, setVehicles] = useState([]);
  const [insuranceCompanies, setInsuranceCompanies] = useState([]);
  const [vehiclesLoading, setVehiclesLoading] = useState(true);
  const [companiesLoading, setCompaniesLoading] = useState(true);
  const [vehicleData, setVehicleData] = useState(null);
  const [customerData, setCustomerData] = useState(null);
  const [customerLoading, setCustomerLoading] = useState(false);

  const insuranceTypeOptions = ["OD", "TP", "Zero Dept", "Consumable"];

  const getStatusColor = (validTill) => {
    if (!validTill) return "#10b981";
    const today = new Date();
    const tillDate = new Date(validTill);
    if (tillDate < today) return "#ef4444";
    const diffDays = Math.ceil((tillDate - today) / (1000 * 60 * 60 * 24));
    return diffDays <= 30 ? "#f59e0b" : "#10b981";
  };

  const getStatusText = (validTill) => {
    if (!validTill) return "Active";
    const today = new Date();
    const tillDate = new Date(validTill);
    if (tillDate < today) return "Expired";
    const diffDays = Math.ceil((tillDate - today) / (1000 * 60 * 60 * 24));
    return diffDays <= 30 ? `${diffDays} days left` : "Active";
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleDateString("en-IN");
  };

  useEffect(() => {
    if (isEdit && existingInsurance) {
      const typeArray = (existingInsurance.insurance_type || "").split(",").filter((t) => t.trim());
      setFormData({
        vehicle_id: existingInsurance.vehicle_id || "",
        insurance_company_id: existingInsurance.insurance_company_id || "",
        insurance_start_date: existingInsurance.insurance_start_date || "",
        insurance_valid_till: existingInsurance.insurance_valid_till || "",
        insurance_amount: existingInsurance.insurance_amount || "",
        insurance_remark: existingInsurance.insurance_remark || "",
        insurance_policy_number: existingInsurance.insurance_policy_number || "",
        insurance_idv: existingInsurance.insurance_idv || "",
        insurance_cng: existingInsurance.insurance_cng || "",
        insurance_ncb: existingInsurance.insurance_ncb || "",
        insurance_under_sgm: existingInsurance.insurance_under_sgm || "1",
        insurance_type: typeArray,
        insurance_policy_document: null,
        insurance_video: null,
        insurance_document: null,
        insurance_grage_id: existingInsurance.insurance_grage_id || grage_id,
      });
      if (existingInsurance) {
        setVehicleData({
          vehicle_reg_no: existingInsurance.vehicle_reg_no || "",
          brand_name: existingInsurance.brand_name || "",
          model_name: existingInsurance.model_name || "",
        });
        if (existingInsurance.customer_name) {
          setCustomerData({
            customer_name: existingInsurance.customer_name,
            customer_mobile: existingInsurance.customer_mobile || "",
          });
        } else if (existingInsurance.customer_id) {
          fetchCustomerDetails(existingInsurance.customer_id);
        }
      }
    } else {
      setFormData((prev) => ({ ...prev, insurance_grage_id: grage_id }));
    }
  }, [isEdit, existingInsurance, grage_id]);

  const fetchVehicles = async () => {
    setVehiclesLoading(true);
    try {
      const fd = new FormData();
      fd.append("company_id", company_id);
      fd.append("vehicle_grage_id", grage_id);
      fd.append("vehicle_reg_no", "");
      fd.append("customer_id", "");
      const response = await axios.post(`${server_url}vehicle.php`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.data.status === "1") {
        setVehicles(
          (response.data.result || []).map((v) => ({
            value: v.vehicle_id,
            label: `${v.vehicle_reg_no} - ${v.brand_name} ${v.model_name} (${v.customer_name || "No Owner"})`,
          }))
        );
      } else {
        setVehicles([]);
      }
    } catch (error) {
      toast.error("Unable to fetch vehicles");
      setVehicles([]);
    } finally {
      setVehiclesLoading(false);
    }
  };

  const fetchCustomerDetails = async (customerId) => {
    setCustomerLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("company_id", company_id);
      params.append("customer_id", customerId);
      params.append("customer_grage_id", grage_id || "");
      params.append("searh_text", "");
      const res = await axios.post(`${server_url}customer.php`, params, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
      if (res.data.status == "1" && res.data.result?.length > 0) {
        setCustomerData(res.data.result[0]);
      }
    } catch (error) {
      console.error("Fetch customer details error:", error);
    } finally {
      setCustomerLoading(false);
    }
  };

  const fetchInsuranceCompanies = async () => {
    setCompaniesLoading(true);
    try {
      const fd = new FormData();
      fd.append("company_id", company_id);
      const response = await axios.post(`${server_url}insurance_company.php`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.data.status === "1") {
        setInsuranceCompanies(
          (response.data.result || []).map((c) => ({
            value: c.insurance_company_id,
            label: c.insurance_company_name,
          }))
        );
      } else {
        setInsuranceCompanies([]);
      }
    } catch (error) {
      toast.error("Unable to fetch insurance companies");
      setInsuranceCompanies([]);
    } finally {
      setCompaniesLoading(false);
    }
  };

  useEffect(() => {
    fetchVehicles();
    fetchInsuranceCompanies();
  }, []);

  useEffect(() => {
    if (formData.vehicle_id && vehicles.length > 0) {
      const sel = vehicles.find((v) => v.value == formData.vehicle_id);
      if (sel && isEdit && !existingInsurance?.vehicle_reg_no) {
        const match = sel.label.match(/^(.*?) - (.*?) \((.*?)\)$/);
        if (match) {
          setVehicleData({
            vehicle_reg_no: match[1] || "",
            brand_name: match[2]?.split(" ")[0] || "",
            model_name: match[2]?.split(" ").slice(1).join(" ") || "",
          });
        }
      }
    }
  }, [formData.vehicle_id, vehicles]);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === "checkbox") {
      const isChecked = e.target.checked;
      setFormData((prev) => ({
        ...prev,
        insurance_type: isChecked
          ? [...prev.insurance_type, value]
          : prev.insurance_type.filter((item) => item !== value),
      }));
    } else if (type === "file") {
      setFormData((prev) => ({ ...prev, [name]: e.target.files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.vehicle_id) newErrors.vehicle_id = "Vehicle is required";
    if (!formData.insurance_company_id) newErrors.insurance_company_id = "Insurance company is required";
    if (!formData.insurance_under_sgm) newErrors.insurance_under_sgm = "Please select if under SGM";
    if (!formData.insurance_start_date) newErrors.insurance_start_date = "Start date is required";
    if (!formData.insurance_valid_till) newErrors.insurance_valid_till = "Valid till date is required";
    if (formData.insurance_amount && isNaN(formData.insurance_amount))
      newErrors.insurance_amount = "Amount must be a number";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      toast.error("Please fix the errors in the form");
      return;
    }
    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append("company_id", company_id);
      fd.append("vehicle_id", formData.vehicle_id);
      fd.append("insurance_company_id", formData.insurance_company_id);
      fd.append("insurance_start_date", formData.insurance_start_date);
      fd.append("insurance_valid_till", formData.insurance_valid_till);
      fd.append("insurance_amount", formData.insurance_amount || 0);
      fd.append("insurance_remark", formData.insurance_remark);
      fd.append("insurance_policy_number", formData.insurance_policy_number);
      fd.append("insurance_idv", formData.insurance_idv);
      fd.append("insurance_cng", formData.insurance_cng);
      fd.append("insurance_ncb", formData.insurance_ncb);
      fd.append("insurance_under_sgm", formData.insurance_under_sgm);
      fd.append("insurance_type", formData.insurance_type.join(","));
      fd.append("insurance_grage_id", formData.insurance_grage_id);

      if (formData.insurance_policy_document)
        fd.append("insurance_policy_document", formData.insurance_policy_document);

      // NEW: append video and document
      if (formData.insurance_video)
        fd.append("insurance_video", formData.insurance_video);
      if (formData.insurance_document)
        fd.append("insurance_document", formData.insurance_document);

      if (isEdit && existingInsurance)
        fd.append("insurance_id", existingInsurance.insurance_id);

      const endpoint = isEdit ? "update_insurance.php" : "add_insurance.php";
      const response = await axios.post(`${server_url}${endpoint}`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.data.status == "1") {
        toast.success(response.data.error || "Insurance saved successfully!");
        navigate("/insurance");
      } else {
        toast.error(response.data.error || "Failed to save insurance");
      }
    } catch (error) {
      toast.error("Unable to save insurance. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleEditCustomer = () => {
    if (customerData) navigate("/edit-customer", { state: { customer: customerData } });
  };

  if (isEdit && !existingInsurance) {
    return (
      <div className="login-container">
        <div className="login-form-container">
          <div style={{ textAlign: "center", padding: "40px" }}>
            <h3>No insurance data found</h3>
            <p>Please go back and select an insurance to edit.</p>
            <Link to="/insurance" style={{ color: "#667eea", textDecoration: "none" }}>
              <i className="fas fa-arrow-left"></i> Back to Insurance
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-form-container">
        <div className="login-form-wrapper">
          {isEdit && existingInsurance && (
            <div
              className="insurance-info-card"
              style={{
                marginBottom: "20px",
                backgroundColor: "#f8f9fa",
                borderRadius: "12px",
                padding: "15px",
                borderLeft: `4px solid ${getStatusColor(existingInsurance.insurance_valid_till)}`,
              }}
            >
              <div
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}
              >
                <div style={{ fontWeight: "bold", fontSize: "16px", color: "#2d3748" }}>
                  {existingInsurance.vehicle_reg_no || ""} {existingInsurance?.brand_name || ""}
                  {existingInsurance?.model_name ? ` ${existingInsurance?.model_name}` : ""}
                </div>
                <div style={{ color: getStatusColor(existingInsurance.insurance_valid_till), fontSize: "12px", fontWeight: "500" }}>
                  {getStatusText(existingInsurance.insurance_valid_till)}
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontSize: "14px", color: "#4a5568" }}>
                  <i className="fas fa-user" style={{ marginRight: "5px" }}></i>
                  <span onClick={handleEditCustomer} style={{ cursor: "pointer", textDecoration: "underline" }}>
                    {customerData?.customer_name || existingInsurance.customer_name || "N/A"}
                  </span>
                  {(customerData?.customer_mobile || existingInsurance.customer_mobile) && (
                    <a style={{ marginLeft: "5px", textDecoration: "underline" }}
                      href={`tel:${customerData?.customer_mobile || existingInsurance.customer_mobile}`}>
                      ({customerData?.customer_mobile || existingInsurance.customer_mobile})
                    </a>
                  )}
                </div>
                <div style={{ fontSize: "14px", color: "#4a5568", display: "-webkit-inline-box" }}>
                  <i className="fas fa-building" style={{ marginRight: "5px" }}></i>
                  <p style={{ width: "100%", marginBottom: "0px" }}>
                    {existingInsurance.insurance_company_name || ""}
                    <span style={{ float: "right", marginRight: "15px" }}>
                      {existingInsurance.insurance_policy_number && <>No: {existingInsurance.insurance_policy_number}</>}
                    </span>
                  </p>
                </div>
                <div style={{ fontSize: "14px", color: "#4a5568", display: "-webkit-inline-box" }}>
                  <i className="fas fa-calendar-alt" style={{ marginRight: "5px" }}></i>
                  <p style={{ width: "100%", marginBottom: "0px" }}>
                    {formatDate(existingInsurance.insurance_start_date)} – {formatDate(existingInsurance.insurance_valid_till)}
                    <span style={{ float: "right", marginRight: "15px", color: "#10b981" }}>
                      ₹{parseFloat(existingInsurance.insurance_amount || 0).toLocaleString("en-IN")}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          )}

          <form className="login-form" onSubmit={handleSubmit}>
            {(!isEdit || !existingInsurance?.vehicle_id) && (
              <div className="form-group">
                <div style={{ display: "-webkit-inline-box", marginBottom: "0px" }}>
                  <span style={{ textAlign: "left", display: "block", marginBottom: "0px", fontWeight: "bold", width: "50%" }}>
                    Vehicle *
                  </span>
                  <span style={{ textAlign: "right", display: "block", marginBottom: "0px", fontWeight: "bold", width: "50%" }}>
                    <Link to="/add-customer-vehicle" style={{ textDecoration: "underline" }}>Add Vehicle</Link>
                  </span>
                </div>
                <SearchableDropdown
                  name="vehicle_id"
                  options={vehicles}
                  value={formData.vehicle_id}
                  onChange={handleChange}
                  placeholder="Select Vehicle"
                  error={errors.vehicle_id}
                  loading={vehiclesLoading}
                  required
                />
              </div>
            )}

            <div className="form-group">
              <label style={{ textAlign: "left", display: "block", marginBottom: "0px", fontWeight: "bold" }}>
                Insurance Company *
              </label>
              <SearchableDropdown
                name="insurance_company_id"
                options={insuranceCompanies}
                value={formData.insurance_company_id}
                onChange={handleChange}
                placeholder="Select Insurance Company"
                error={errors.insurance_company_id}
                loading={companiesLoading}
                required
              />
            </div>

            <div className="form-group">
              <label style={{ textAlign: "left", display: "block", marginBottom: "0px", fontWeight: "bold" }}>
                Policy Number
              </label>
              <div className="input-group">
                <div className="input-icon"><i className="fas fa-file-alt"></i></div>
                <input
                  type="text"
                  name="insurance_policy_number"
                  className="form-input"
                  placeholder="Policy Number"
                  value={formData.insurance_policy_number}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-row" style={{ display: "ruby" }}>
              <div className="form-group" style={{ flex: 1, width: "49%" }}>
                <label style={{ textAlign: "left", display: "block", marginBottom: "0px", fontWeight: "bold" }}>
                  Start Date *
                </label>
                <div className="input-group">
                  <div className="input-icon"><i className="fas fa-calendar-alt"></i></div>
                  <input
                    type="date"
                    name="insurance_start_date"
                    className={`form-input ${errors.insurance_start_date ? "error" : ""}`}
                    value={formData.insurance_start_date}
                    onChange={handleChange}
                    required
                  />
                </div>
                {errors.insurance_start_date && (
                  <div className="error-message">
                    <i className="fas fa-exclamation-circle"></i>{errors.insurance_start_date}
                  </div>
                )}
              </div>
              <div className="form-group marginleft5" style={{ flex: 1, marginLeft: "5px", width: "49%" }}>
                <label style={{ textAlign: "left", display: "block", marginBottom: "0px", fontWeight: "bold" }}>
                  Valid Till *
                </label>
                <div className="input-group">
                  <div className="input-icon"><i className="fas fa-calendar-check"></i></div>
                  <input
                    type="date"
                    name="insurance_valid_till"
                    className={`form-input ${errors.insurance_valid_till ? "error" : ""}`}
                    value={formData.insurance_valid_till}
                    onChange={handleChange}
                    required
                  />
                </div>
                {errors.insurance_valid_till && (
                  <div className="error-message">
                    <i className="fas fa-exclamation-circle"></i>{errors.insurance_valid_till}
                  </div>
                )}
              </div>
            </div>

            <div className="form-group">
              <label style={{ textAlign: "left", display: "block", marginBottom: "0px", fontWeight: "bold" }}>
                Insurance Amount (₹)
              </label>
              <div className="input-group">
                <div className="input-icon"><i className="fas fa-rupee-sign"></i></div>
                <input
                  type="number"
                  name="insurance_amount"
                  className={`form-input ${errors.insurance_amount ? "error" : ""}`}
                  placeholder="Amount"
                  value={formData.insurance_amount}
                  onChange={handleChange}
                  step="0.01"
                  min="0"
                />
              </div>
              {errors.insurance_amount && (
                <div className="error-message">
                  <i className="fas fa-exclamation-circle"></i>{errors.insurance_amount}
                </div>
              )}
            </div>

            <div className="form-group">
              <label style={{ textAlign: "left", display: "block", marginBottom: "0px", fontWeight: "bold" }}>
                Insurance Type
              </label>
              <div className="checkbox-group" style={{ display: "-webkit-box" }}>
                {insuranceTypeOptions.map((type) => (
                  <div key={type} className="checkbox-option" style={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="checkbox"
                      id={`insurance_type_${type}`}
                      name="insurance_type"
                      value={type}
                      checked={formData.insurance_type.includes(type)}
                      onChange={handleChange}
                      style={{ marginRight: "4px" }}
                    />
                    <label htmlFor={`insurance_type_${type}`}
                      style={{ cursor: "pointer", marginBottom: "0px", fontSize: "14px" }}>
                      {type}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            {/* Policy Document */}
            <div className="form-group">
              <label style={{ textAlign: "left", display: "block", marginBottom: "0px", fontWeight: "bold" }}>
                Policy Document
              </label>
              <div className="input-group">
                <div className="input-icon"><i className="fas fa-file-pdf"></i></div>
                <input
                  type="file"
                  name="insurance_policy_document"
                  className="form-input"
                  onChange={handleChange}
                  accept=".pdf,.jpg,.jpeg,.png"
                />
              </div>
              {isEdit && existingInsurance?.insurance_policy_document && (
                <div style={{ marginTop: "6px", fontSize: "13px" }}>
                  <a href={existingInsurance.insurance_policy_document} target="_blank" rel="noopener noreferrer"
                    style={{ color: "#0352a1", textDecoration: "none" }}>
                    <i className="fas fa-eye" style={{ marginRight: "5px" }}></i>View Current Document
                  </a>
                </div>
              )}
            </div>

            {/* ───────── NEW: Video Upload ───────── */}
            <div className="form-group">
              <label style={{ textAlign: "left", display: "block", marginBottom: "0px", fontWeight: "bold" }}>
                Upload Video
              </label>
              <div className="input-group">
                <div className="input-icon"><i className="fas fa-video"></i></div>
                <input
                  type="file"
                  name="insurance_video"
                  className="form-input"
                  onChange={handleChange}
                  accept="video/*"
                />
              </div>
              {formData.insurance_video && (
                <div style={{ marginTop: "6px", fontSize: "13px", color: "#4a5568" }}>
                  <i className="fas fa-check-circle" style={{ marginRight: "5px", color: "#10b981" }}></i>
                  {formData.insurance_video.name}
                </div>
              )}
              {isEdit && existingInsurance?.insurance_video && !formData.insurance_video && (
                <div style={{ marginTop: "6px", fontSize: "13px" }}>
                  <a href={existingInsurance.insurance_video} target="_blank" rel="noopener noreferrer"
                    style={{ color: "#0352a1", textDecoration: "none" }}>
                    <i className="fas fa-play-circle" style={{ marginRight: "5px" }}></i>View Current Video
                  </a>
                </div>
              )}
            </div>

            {/* ───────── NEW: Extra Document (PDF) Upload ───────── */}
            <div className="form-group">
              <label style={{ textAlign: "left", display: "block", marginBottom: "0px", fontWeight: "bold" }}>
                Upload Document (PDF)
              </label>
              <div className="input-group">
                <div className="input-icon"><i className="fas fa-file-alt"></i></div>
                <input
                  type="file"
                  name="insurance_document"
                  className="form-input"
                  onChange={handleChange}
                  accept=".pdf"
                />
              </div>
              {formData.insurance_document && (
                <div style={{ marginTop: "6px", fontSize: "13px", color: "#4a5568" }}>
                  <i className="fas fa-check-circle" style={{ marginRight: "5px", color: "#10b981" }}></i>
                  {formData.insurance_document.name}
                </div>
              )}
              {isEdit && existingInsurance?.insurance_document && !formData.insurance_document && (
                <div style={{ marginTop: "6px", fontSize: "13px" }}>
                  <a href={existingInsurance.insurance_document} target="_blank" rel="noopener noreferrer"
                    style={{ color: "#0352a1", textDecoration: "none" }}>
                    <i className="fas fa-eye" style={{ marginRight: "5px" }}></i>View Current Document
                  </a>
                </div>
              )}
            </div>

            <div className="form-group">
              <label style={{ textAlign: "left", display: "block", marginBottom: "5px", fontWeight: "bold" }}>
                Remarks
              </label>
              <div className="input-group">
                <div className="input-icon"><i className="fas fa-comment"></i></div>
                <textarea
                  name="insurance_remark"
                  className="form-input textarea"
                  placeholder="Any remarks or notes..."
                  value={formData.insurance_remark}
                  onChange={handleChange}
                  rows="3"
                />
              </div>
            </div>

            <input type="hidden" name="insurance_grage_id" value={formData.insurance_grage_id} />

            <button
              type="submit"
              className="login-button"
              disabled={submitting || vehiclesLoading || companiesLoading}
            >
              <i className="fas fa-save"></i>
              {submitting ? "Saving..." : isEdit ? "Update Insurance" : "Add Insurance"}
            </button>
          </form>
        </div>
      </div>
      <style jsx>{`
        .marginleft5 { margin-left: 5px !important; }
        .login-container { min-height: 100vh; background: #f8f9fa; display: flex; align-items: center; justify-content: center; }
        .login-form-container { width: 100%; max-width: 600px; background: white; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); overflow: hidden; }
        @media (max-width: 768px) { .login-form-container { flex: none; padding: 0px; } }
        .login-form-wrapper { padding: 20px; }
        .login-form { display: flex; flex-direction: column; gap: 0px; }
        .form-group { display: flex; flex-direction: column; gap: 5px; }
        .form-row { display: flex; gap: 10px; }
        label { font-weight: 600; color: #4a5568; font-size: 14px; }
        .input-group { position: relative; display: flex; align-items: center; }
        .input-icon { position: absolute; left: 12px; color: #a0aec0; z-index: 1; font-size: 16px; }
        .form-input { width: 100%; padding: 10px 12px 10px 40px; border: 2px solid #e2e8f0; border-radius: 8px; font-size: 14px; transition: all 0.3s; background: white; }
        .form-input:focus { outline: none; border-color: #0352a1; box-shadow: 0 0 0 3px rgba(3,82,161,0.1); }
        .form-input.error { border-color: #dc2626; }
        .form-input.textarea { min-height: 80px; resize: vertical; padding-top: 10px; padding-bottom: 10px; }
        .searchable-dropdown { position: relative; }
        .dropdown-list { position: absolute; top: 100%; left: 0; right: 0; background: white; border: 1px solid #e2e8f0; border-radius: 8px; max-height: 200px; overflow-y: auto; z-index: 1000; margin-top: 2px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); }
        .dropdown-item { padding: 8px 12px; cursor: pointer; transition: background 0.2s; font-size: 14px; }
        .dropdown-item:hover { background: #f7fafc; }
        .dropdown-item.no-results { color: #a0aec0; text-align: center; }
        .radio-group, .checkbox-group { display: flex; flex-wrap: wrap; gap: 15px; margin-top: 5px; }
        .radio-option, .checkbox-option { display: flex; align-items: center; cursor: pointer; }
        .radio-option input[type="radio"], .checkbox-option input[type="checkbox"] { width: 18px; height: 18px; margin-right: 8px; cursor: pointer; }
        .radio-option label, .checkbox-option label { cursor: pointer; user-select: none; font-size: 14px; color: #333; }
        .error-message { color: #dc2626; font-size: 12px; margin-top: 4px; display: flex; align-items: center; gap: 6px; }
        .loading-message { color: #666; font-size: 12px; margin-top: 4px; display: flex; align-items: center; gap: 6px; }
        .login-button { background: #0352a1; color: white; border: none; padding: 12px; border-radius: 8px; font-size: 16px; font-weight: 600; cursor: pointer; transition: background 0.3s; display: flex; align-items: center; justify-content: center; gap: 10px; margin-top: 10px; }
        .login-button:hover:not(:disabled) { background: #024080; }
        .login-button:disabled { opacity: 0.6; cursor: not-allowed; }
        @media (max-width: 768px) {
          .login-form-wrapper { padding: 15px; }
          .form-row { flex-direction: column; gap: 0px; }
          .radio-group, .checkbox-group { flex-direction: column; gap: 10px; }
        }
      `}</style>
    </div>
  );
};

export default AddInsurance;